import { useState, useEffect } from 'react';
import './style.css';
import { getAllSubContableAcounts } from '../../../usecases/contable-acounts-usecase';
import MultiSearchDropdown from '../../atoms/multiSearchDropdown/view';

const MultiSubaccountSearchDropdown = ({ onSelected, selected = [] }) => {
    const [allSubaccounts, setAllSubaccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSubaccounts = async (force = false) => {
        try {
            setLoading(true);
            setError(null);
            const fetchedSubaccounts = await getAllSubContableAcounts("", "", force);
            // Fix: the usecase returns the array directly, not an object with a .data property
            const data = Array.isArray(fetchedSubaccounts) ? fetchedSubaccounts : [];
            
            setAllSubaccounts(data.map(item => {
                const paddedCode = String(item.code ?? '').padStart(2, '0');
                return {
                    ...item,
                    name: `${item.base_account?.account || ''}${paddedCode} - ${item.description || item.base_account?.description || ''}`
                }
            }));
        } catch (err) {
            console.error("Error loading account data:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubaccounts();
    }, []);

    if (loading) return <div className="p-2 small opacity-50">Cargando cuentas...</div>;
    if (error) return <div className="text-danger small">Error cargando cuentas.</div>;

    return (
        <MultiSearchDropdown
            placeholder="Seleccionar auxiliares..."
            options={allSubaccounts}
            path="name"
            onSelected={onSelected}
            selected={selected}
        />
    );
};

export default MultiSubaccountSearchDropdown;
